import PropTypes from 'prop-types'

import AtomLabel from '@s-ui/react-atom-label'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'

import {BASE_ELEMENTS} from '../../config.js'

const FormVehiclesLabel = ({hidden = false, id, label}) => {
  return hidden ? (
    <VisuallyHidden as={BASE_ELEMENTS.LABEL} htmlFor={id}>
      {label}
    </VisuallyHidden>
  ) : (
    <AtomLabel htmlFor={id}>{label}</AtomLabel>
  )
}

FormVehiclesLabel.displayName = 'FormVehiclesLabel'
FormVehiclesLabel.propTypes = {
  hidden: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string
}

export default FormVehiclesLabel
